import React, {createContext, useEffect, useState} from 'react';
import {useResizeListener} from "primereact/hooks";
import {LiveSessionInfoDto, LoginResponseDto} from "../services/api";

interface UserInfo extends LoginResponseDto{
    authenticated: boolean,
    liveSessionInfo: LiveSessionInfoDto | null
}

export interface UserContextType {
    userInfo: UserInfo;
    updateUserInfo: (userInfo: Partial<UserInfo>) => void;
    isMobile: boolean;
}

export const UserContext = createContext<UserContextType>({} as UserContextType);

export const UserContextProvider = (props: any) => {
    const initialState : UserInfo = {
        authenticated: false,
        userId: undefined,
        liveSessionInfo: null
    }
    const [userInfo, setUserInfo] = useState(initialState);

    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

    const [bindWindowResizeListener, unbindWindowResizeListener] = useResizeListener({
        listener: (event) => {
            if(event.currentTarget && 'innerWidth' in event.currentTarget)
            setIsMobile((event.currentTarget.innerWidth as number) < 992);
        }
    });

    useEffect(() => {
        bindWindowResizeListener();

        return () => {
            unbindWindowResizeListener();
        };
    }, [bindWindowResizeListener, unbindWindowResizeListener]);

    const updateUserInfo = (userInfo : Partial<UserInfo>) => {
        setUserInfo(prevState => {return {...prevState, ...userInfo}});
    }

    return <>
        <UserContext.Provider value={{userInfo, updateUserInfo, isMobile}}>
            {props.children}
        </UserContext.Provider>
    </>
};
